import React, { useState } from "react";
import {
  Header,
  Nav,
  LogoContainer,
  Logo,
  NavList,
  NavItem,
  NavLink,
  Burger,
  BurgerContainer,
  BurgerLabel,
  BurgerCheckbox,
} from "./Navbar.elements";
import logoGreen from "../../Images/logoGreen.svg";

const Navbar = ({ active }) => {
  const links = ["Pocetna", "O nama", "Prodavnica", "Kontakt"];
  const [open, setOpen] = useState(false);
  return (
    <Header>
      <Nav className="res-cnt">
        <LogoContainer>
          <Logo src={logoGreen} />
        </LogoContainer>
        <BurgerLabel
          htmlFor="burger"
          onClick={() => {
            setOpen(!open);
          }}
        >
          <BurgerContainer>
            <Burger className={open && "open"} />
          </BurgerContainer>
        </BurgerLabel>
        <BurgerCheckbox type="checkbox" id="burger" />

        <NavList className={open && "open"}>
          {links.map((link, index) => {
            let isActive = link == active;

            return (
              <NavItem key={index}>
                <NavLink isActive={isActive}>{link}</NavLink>
              </NavItem>
            );
          })}
        </NavList>
      </Nav>
    </Header>
  );
};

export default Navbar;
